export default
{
  menu_element: {
    color: '#757575',
    text: 'Menu główne',
  },
  agent: {
    color: '#7ddb30',
    text: 'Agent',
  },
  project: {
    color: '#efd92f',
    text: 'Projekt',
  },
  menu_b: {
    color: '#efd92f',
    text: 'Menu alternatywne',
  },
};
